/**
 * ---------------------------------------------------------------------
 * 🔒 AUTOGENERATED BY VENDORISM
 * Removing this comment will prevent it from being managed by it.
 * ---------------------------------------------------------------------
 */

/* eslint-disable */
import SynTag from './tag.component.js';

export * from './tag.component.js';
export default SynTag;

SynTag.define('syn-tag');

declare global {
  interface HTMLElementTagNameMap {
    'syn-tag': SynTag;
  }
}
